import classes from './NotificationsAlert.module.scss';
import { Popover } from 'antd';
import { Icon, preventDefault, useMobile } from '@app/ui';
import { NotificationAlertOverlay } from './NotificationAlertOverlay';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useAppWispoUnreadCount } from '@app/notifications/api';
import { NotificationsSettingsPanel } from '../Notifications.Settings/NotificationsSettingsPanel';
import { useCallback, useState } from 'react';

export function NotificationsAlert() {
  const { t } = useTranslation();
  const unread = useAppWispoUnreadCount();
  const { isMobile } = useMobile();
  const [showSettings, setShowSettings] = useState(false);
  const onOpenSettings = useCallback(() => setShowSettings(true), [setShowSettings]);
  const onCloseSettings = useCallback(() => setShowSettings(false), [setShowSettings]);

  return (
    <>
      <Popover
        content={<NotificationAlertOverlay onOpenSettings={onOpenSettings} />}
        placement="bottomRight"
        destroyTooltipOnHide
        autoAdjustOverflow
        overlayClassName={classes.overlay}
      >
        <a
          href="/"
          className={classNames('ant-dropdown-link', classes.anchor, 'NotificationsAlert')}
          onClick={preventDefault}
        >
          <span className={classes.container}>
            {!isMobile && <Icon type="bell" className={classes.icon} />}
            {isMobile && t('notifications.list.title')}
            <div className={classNames(classes.count, { [classes.mobile]: isMobile })}>
              {unread !== undefined ? unread : '?'}
            </div>
          </span>
        </a>
      </Popover>
      {showSettings && <NotificationsSettingsPanel onClose={onCloseSettings} />}
    </>
  );
}
